/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/provider',
                name: 'provider',
                component: () => import('./views/provider.vue')
              },
              {
                path: '/clients',
                name: 'clients',
                component: () => import('./views/clients.vue')
              },
              {
                path: '/shopping',
                name: 'shopping',
                component: () => import('./views/shopping.vue')
              },
              {
                path: '/company',
                name: 'company',
                component: () => import('./views/company.vue')
              },
              {
                path: '/products',
                name: 'products',
                component: () => import('./views/products.vue')
              },
              {
                path: '/containers',
                name: 'containers',
                component: () => import('./views/containers.vue')
              },
              {
                path: '/simulation',
                name: 'simulation',
                component: () => import('./views/simulation.vue')
              },
              {
                path: '/containersType',
                name: 'containersType',
                component: () => import('./views/containersType.vue')
              },

            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
